<div class="row text-left nudge-banner-container" [ngStyle]="{'background-color': bannerColorHex, 'color': bannerTextColorHex}">
  <div col-lg-12 col-md-12 col-sm-12 col-xs-12>
    <p>{{bannerMessageText}}</p>
    <span (click)="close()"  class="pull-right">Close</span>
  </div>
</div>